import { styled } from '../../../theme/styled';
import { TabsTokens } from '../model';

export const TabHeaderItem = styled('div', {
  name: 'Tabs',
  slot: 'HeaderItem',
})(({ theme }) => {
  return {
    ...theme.typography.button,
    color: TabsTokens.TextColor(theme.palette['gray dark']),
    cursor: 'pointer',
    position: 'relative',
    padding: 8,
    WebkitTapHighlightColor: 'transparent',
    '&:focus, &:active': {
      outline: 'none',
    },
    '&:hover': {
      color: TabsTokens.HoverColor(theme.palette['brand gray']),
    },
    '&[data-active="true"]': {
      [TabsTokens.TextColor]: TabsTokens.ActiveTextColor(theme.palette['brand gray']),
      [TabsTokens.HoverColor]: TabsTokens.ActiveTextColor(theme.palette['brand gray']),
    },
  };
});
